"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("./utils");
var _useFormContext = _interopRequireDefault(require("../../../../hooks/useFormContext"));
var _sprintf = _interopRequireDefault(require("../../../../../../utils/sprintf"));
var _dateFns = require("date-fns");
var _react = require("react");
var _server = require("react-dom/server");
var _uuid = require("uuid");
var _sv = _interopRequireDefault(require("../../../../sv.json"));
var FSTypes = _interopRequireWildcard(require("../../../../types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var validationName = "daterange";
var DateRange = function DateRange(props) {
  var _a, _b, _c, _d, _e, _f;
  var blockSelection = props.blockSelection,
    children = props.children,
    i18n = props.i18n,
    fieldName = props.fieldName,
    maxExclusive = props.maxExclusive,
    maxFieldName = props.maxFieldName,
    minExclusive = props.minExclusive,
    minFieldName = props.minFieldName,
    _g = props.type,
    type = _g === void 0 ? FSTypes.ValidationTypes.Error : _g,
    validateOnChange = props.validateOnChange;
  var uuid = (0, _react.useState)((0, _uuid.v4)())[0];
  var _h = (0, _useFormContext.default)(),
    addAdditionalInputProp = _h.addAdditionalInputProp,
    addFormValidation = _h.addFormValidation,
    formData = _h.formData,
    formI18n = _h.i18n,
    getFieldLabel = _h.getFieldLabel,
    removeFormValidation = _h.removeFormValidation;
  (0, _react.useEffect)(function () {
    var _a, _b, _c, _d;
    if (!blockSelection) {
      return;
    }
    var _e = (0, _utils.getDates)(formData, fieldName, minFieldName, minExclusive, maxFieldName, maxExclusive),
      maxDate = _e.maxDate,
      minDate = _e.minDate;
    var currentMinDate = (_b = (_a = formData === null || formData === void 0 ? void 0 : formData[fieldName]) === null || _a === void 0 ? void 0 : _a.additionalInputProps) === null || _b === void 0 ? void 0 : _b.minDate;
    var currentMaxDate = (_d = (_c = formData === null || formData === void 0 ? void 0 : formData[fieldName]) === null || _c === void 0 ? void 0 : _c.additionalInputProps) === null || _d === void 0 ? void 0 : _d.maxDate;
    if (!currentMinDate && minDate || currentMinDate && !minDate || currentMinDate && minDate && _typeof(currentMinDate) === "object" && currentMinDate.getTime() !== minDate.getTime()) {
      addAdditionalInputProp(fieldName, "minDate", minDate);
    }
    if (!currentMaxDate && maxDate || currentMaxDate && !maxDate || currentMaxDate && maxDate && _typeof(currentMaxDate) === "object" && currentMaxDate.getTime() !== maxDate.getTime()) {
      addAdditionalInputProp(fieldName, "maxDate", maxDate);
    }
  }, [addAdditionalInputProp, blockSelection, fieldName, formData, maxExclusive, maxFieldName, minExclusive, minFieldName]);
  (0, _react.useEffect)(function () {
    return function () {
      addAdditionalInputProp(fieldName, "minDate", undefined);
      addAdditionalInputProp(fieldName, "maxDate", undefined);
    };
  }, [addAdditionalInputProp, fieldName]);
  (0, _react.useEffect)(function () {
    if (!blockSelection) {
      addAdditionalInputProp(fieldName, "minDate", undefined);
      addAdditionalInputProp(fieldName, "maxDate", undefined);
    }
  }, [addAdditionalInputProp, blockSelection, fieldName]);
  var validation = (0, _react.useCallback)(function (validationFormData) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var _j = (0, _utils.getDates)(validationFormData, fieldName, minFieldName, minExclusive, maxFieldName, maxExclusive),
      compareDate = _j.compareDate,
      maxDate = _j.maxDate,
      minDate = _j.minDate;
    var validationMessages = [];
    var variables = {
      fieldName: fieldName || "",
      label: fieldName && getFieldLabel(fieldName) || "",
      minDate: minDate ? (0, _dateFns.format)(minDate, "yyyy-MM-dd") : "",
      minDateTime: minDate ? (0, _dateFns.format)(minDate, "yyyy-MM-dd HH:mm") : "",
      minLabel: minFieldName && getFieldLabel(minFieldName) || "",
      minTime: minDate ? (0, _dateFns.format)(minDate, "HH:mm") : "",
      maxDate: maxDate ? (0, _dateFns.format)(maxDate, "yyyy-MM-dd") : "",
      maxDateTime: maxDate ? (0, _dateFns.format)(maxDate, "yyyy-MM-dd HH:mm") : "",
      maxLabel: maxFieldName && getFieldLabel(maxFieldName) || "",
      maxTime: maxDate ? (0, _dateFns.format)(maxDate, "HH:mm") : "",
      valueDate: compareDate ? (0, _dateFns.format)(compareDate, "yyyy-MM-dd") : "",
      valueDateTime: compareDate ? (0, _dateFns.format)(compareDate, "yyyy-MM-dd HH:mm") : "",
      valueTime: compareDate ? (0, _dateFns.format)(compareDate, "HH:mm") : ""
    };
    if (compareDate && minDate && (0, _dateFns.isBefore)(compareDate, minDate)) {
      validationMessages.push({
        fieldName: fieldName,
        involvedFieldNames: [minFieldName],
        type: type,
        text: children !== undefined ? (0, _server.renderToString)((0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: children
        })) : (0, _sprintf.default)((i18n === null || i18n === void 0 ? void 0 : i18n.min) || ((_c = (_b = (_a = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.dateRange) === null || _c === void 0 ? void 0 : _c.min) || ((_d = _sv.default.validation.form.dateRange) === null || _d === void 0 ? void 0 : _d.min), variables)
      });
    }
    if (compareDate && maxDate && (0, _dateFns.isAfter)(compareDate, maxDate)) {
      validationMessages.push({
        fieldName: fieldName,
        involvedFieldNames: [maxFieldName],
        type: type,
        text: children !== undefined ? (0, _server.renderToString)((0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: children
        })) : (0, _sprintf.default)((i18n === null || i18n === void 0 ? void 0 : i18n.max) || ((_g = (_f = (_e = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _e === void 0 ? void 0 : _e.form) === null || _f === void 0 ? void 0 : _f.dateRange) === null || _g === void 0 ? void 0 : _g.max) || ((_h = _sv.default.validation.form.dateRange) === null || _h === void 0 ? void 0 : _h.max), variables)
      });
    }
    return validationMessages;
  }, [children, fieldName, (_c = (_b = (_a = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.dateRange) === null || _c === void 0 ? void 0 : _c.max, (_f = (_e = (_d = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _d === void 0 ? void 0 : _d.form) === null || _e === void 0 ? void 0 : _e.dateRange) === null || _f === void 0 ? void 0 : _f.min, getFieldLabel, i18n === null || i18n === void 0 ? void 0 : i18n.max, i18n === null || i18n === void 0 ? void 0 : i18n.min, maxExclusive, maxFieldName, minExclusive, minFieldName, type]);
  (0, _react.useEffect)(function () {
    addFormValidation("".concat(validationName, "_").concat(uuid), [fieldName, maxFieldName, minFieldName].filter(Boolean), validation, validateOnChange);
    return function () {
      removeFormValidation("".concat(validationName, "_").concat(uuid));
    };
  }, [addFormValidation, fieldName, maxFieldName, minFieldName, removeFormValidation, uuid, validateOnChange, validation]);
  return null;
};
var _default = DateRange;
exports.default = _default;